<template>
  <div class="wrap">
    <myHead />
    <div class="wrap_body as-detail-page" v-loading="pageLoading">
      <div class="center as-detail-center">
        <div class="page_links">
          当前位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/uc_after_sales' }">售后管理</el-breadcrumb-item>
            <el-breadcrumb-item>售后详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div v-if="loadError" class="as-detail-error">
          <p>{{ loadError }}</p>
          <el-button type="primary" plain size="small" @click="$router.push('/uc_after_sales')">返回列表</el-button>
        </div>

        <template v-else-if="aftersale">
          <div class="as-detail-layout">
            <!-- 左侧主栏 -->
            <div class="as-detail-main">
              <div class="as-card as-status-card">
                <div class="as-steps-inner">
                  <div class="as-step-bar">
                    <div
                        v-for="(item, idx) in processStepBarList"
                        :key="item.key"
                        class="as-step-bar-cell"
                    >
                      <div class="as-step-bar-seg" :class="'as-step-bar-seg--' + item.uiState">
												<span class="as-step-bar-icon" aria-hidden="true">
													<i v-if="item.uiState === 'done'" class="el-icon-check"></i>
													<i v-else-if="item.uiState === 'error'" class="el-icon-close"></i>
													<span v-else-if="item.uiState === 'current'" class="as-step-bar-dot-inner"></span>
													<span v-else class="as-step-bar-dot-inner is-muted"></span>
												</span>
                        <span class="as-step-bar-title">{{ item.title }}</span>
                      </div>
                      <span
                          v-if="idx < processStepBarList.length - 1"
                          class="as-step-bar-line"
                          aria-hidden="true"
                      />
                    </div>
                  </div>
                </div>
                <h2 class="as-status-title">{{ statusHeadline }}</h2>
                <p class="as-countdown" v-if="countdownText">
                  请在 <span class="as-countdown-num">{{ countdownText }}</span> 内处理，超时未处理将自动同意退款
                </p>
                <div class="as-action-btns">
                  <template v-if="operateList.length">
                    <el-button
                        v-for="op in operateList"
                        :key="op.val"
                        :type="primaryOperateVals.includes(op.val) ? 'primary' : 'default'"
                        plain
                        size="medium"
                        class="as-op-btn"
                        @click="openOperate(op)">
                      {{ op.text }}
                    </el-button>
                  </template>

                  <el-button
                      v-if="showExtendReceiptStub"
                      size="medium"
                      plain
                      :loading="extendReceiptSubmitting"
                      @click="confirmExtendReceipt">
                    延长收货
                  </el-button>
                  <template v-if="showLogisticsInterceptUi">
                    <el-button
                        v-if="logisticsInterceptStateNum === 0"
                        size="medium"
                        plain
                        :loading="logisticsInterceptSubmitting"
                        @click="confirmApplyLogisticsIntercept"
                    >
                      申请物流拦截
                    </el-button>
                    <el-tag
                        v-else
                        size="medium"
                        :type="logisticsInterceptTagType"
                        effect="plain"
                        class="as-op-btn as-intercept-tag"
                    >
                      {{ logisticsInterceptStatusText }}
                    </el-tag>
                  </template>
                </div>
                <p class="as-remark-line as-remark-line--order" v-if="aftersale">
                  <span class="as-remark-k">订单备注：</span>
                  <i
                      v-if="orderSellerRemarkFlagShow"
                      class="el-icon-s-flag as-order-flag"
                      :style="{ color: orderSellerRemarkFlagColor }"
                      aria-hidden="true"
                  />
                  <span class="as-remark-val">{{ orderDetailSellerWordsDisplay }}</span>
                  <a
                      v-if="orderIdForRemarkDialog"
                      href="javascript:;"
                      class="as-link-muted"
                      @click="openRemarkDialog('order')"
                  >修改</a>
                </p>
                <p class="as-remark-line">
                  <span class="as-remark-k">售后备注：</span>
                  <span class="as-remark-val">{{ buyerRemark || '暂无' }}</span>
                  <a href="javascript:;" class="as-link-muted" @click="openRemarkDialog('aftersale')">修改备注</a>
                </p>
              </div>

              <div class="as-card">
                <div class="as-card-hd">
                  <span class="as-card-title">售后信息</span>
                  <el-tag size="small" type="primary">{{ typeTagText }}</el-tag>
                </div>
                <div class="as-info-grid">
                  <div class="as-info-row">
                    <span class="label">订单编号</span>
                    <span class="val">
											<a target="_blank" :href="`https://fxg.jinritemai.com/ffa/morder/order/detail?id=`+ shopOrderId">{{ shopOrderId }}</a>
											<i class="el-icon-document-copy as-copy" @click="copyText(shopOrderId)" /></span>
                    <span class="label">下单时间</span>
                    <span class="val">{{ orderCreateTime || PLACEHOLDER.orderTime }}</span>
                  </div>
                  <div class="as-info-row">
                    <span class="label">售后编号</span>
                    <span class="val">
											<a target="_blank" :href="`https://fxg.jinritemai.com/ffa/maftersale/aftersale/detail-v3?aftersale_id=`+ aftersale.aftersale_id">{{ aftersale.aftersale_id }}</a>
											<i class="el-icon-document-copy as-copy" @click="copyText(String(aftersale.aftersale_id))" /></span>
                    <span class="label">申请时间</span>
                    <span class="val">{{ applyTimeText }}</span>
                  </div>

                  <div class="as-info-row">
                    <span class="label">申请金额</span>
                    <span class="val">{{ formatYuan(aftersale.refund_amount) }}</span>
                    <span class="label">消费者应退款</span>
                    <span class="val as-money">{{ consumerRefundText }}</span>
                  </div>
                  <div class="as-info-row">
                    <span class="label">收货状态</span>
                    <span class="val">{{ receiptStatusText}}</span>
                    <span class="label">申请件数</span>
                    <span class="val">{{ aftersale.aftersale_num != null ? aftersale.aftersale_num + ' 件' : '-' }}</span>
                  </div>
                  <div class="as-info-row">
                    <span class="label">消费者寄回数量</span>
                    <span class="val">{{ returnNumText}}</span>
                    <span class="label">售后原因</span>
                    <span class="val">{{ reasonText}}</span>
                  </div>
                  <div class="as-info-block" v-if="aftersale.aftersale_type == 3">
                    <p><span class="label">换货规格</span>{{ aftersale.exchange_sku_info.spec_desc}} x {{aftersale.exchange_sku_info.num }}</p>
                  </div>
                </div>
              </div>

              <div class="as-card">
                <div class="as-card-hd"><span class="as-card-title">交易信息</span></div>
                <div class="as-trade-product" v-if="orderProduct">
                  <div class="as-pro-img"><img :src="orderProduct.product_pic" alt="" /></div>
                  <div class="as-pro-body">
                    <p class="as-pro-title">{{ orderProduct.product_name }}</p>
                    <p class="as-pro-meta">ID：{{ orderProduct.goods_id || orderProduct.dd_goods_id || '-' }}</p>
                    <p class="as-pro-spec">{{ orderProduct.spec_value || '-' }} x {{ orderProduct.item_num }}</p>
                    <!-- <p class="as-pro-tags">
                      <el-tag size="mini" type="danger" effect="plain">极速退</el-tag>
                      <el-tag size="mini" effect="plain">运费险</el-tag>
                      <el-tag size="mini" effect="plain">7天无理由</el-tag>
                      <el-tag size="mini" effect="plain">15天售后期</el-tag>
                    </p> -->
                  </div>
                </div>
                <div class="as-trade-footer">
                  <span>订单编号 {{ shopOrderId }}</span>
                  <span>下单时间 {{ orderCreateTime || PLACEHOLDER.orderTime }}</span>
                  <span>发货状态 {{ shipStatusText }}</span>
                  <span>用户实付 <strong>{{ userPaidText }}</strong>
                    <!-- <i class="el-icon-warning-outline as-tip-icon" title="示例提示" /> -->
									</span>
                </div>
              </div>
            </div>

            <!-- 右侧栏 -->
            <div class="as-detail-side">
              <div class="as-card">
                <div class="as-card-hd"><span class="as-card-title">协商记录</span></div>
                <el-timeline v-if="timelineRecords.length">
                  <el-timeline-item
                      v-for="(rec, idx) in timelineRecordsDisplay"
                      :key="'neg-' + idx + '-' + (rec.time || '') + '-' + (rec.action || '')"
                      :timestamp="rec.time || ''"
                      placement="top"
                      :type="rec.role === 1 ? 'danger' : 'primary'"
                      :icon="rec.role === 1 ? 'el-icon-user-solid' : 'el-icon-s-tools'">
                    <p class="as-tl-action">{{ rec.action || '节点' }}</p>
                    <p class="as-tl-text">{{ rec.text }}</p>
                    <div v-if="rec.desc_kvs && rec.desc_kvs.length" class="as-tl-kvs">
                      <p v-for="(kv, ki) in rec.desc_kvs" :key="ki"><em>{{ kv.key }}</em>：{{ kv.value }}</p>
                    </div>
                    <div v-if="negotiationEvidenceBlocks(rec).length" class="as-tl-evidence">
                      <p class="as-tl-evidence-hd">凭证信息</p>
                      <div
                          v-for="(blk, bi) in negotiationEvidenceBlocks(rec)"
                          :key="'ev-' + idx + '-' + bi"
                          class="as-tl-evidence-block"
                      >
                        <p v-if="blk.desc" class="as-tl-evidence-desc">{{ blk.desc }}</p>
                        <div v-if="blk.urls.length" class="as-tl-evidence-imgs">
                          <el-image
                              v-for="(url, ui) in blk.urls"
                              :key="'evu-' + idx + '-' + bi + '-' + ui"
                              class="as-tl-evidence-thumb"
                              :src="url"
                              fit="cover"
                              :preview-src-list="negotiationEvidenceAllUrls(rec)"
                          />
                        </div>
                      </div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
                <div v-else class="as-timeline-placeholder">
                  <p v-for="(t, i) in placeholderTimelineDisplay" :key="i">{{ t }}</p>
                </div>
                <div v-if="negotiationNeedToggle" class="as-negotiation-toggle">
                  <el-button type="text" size="small" class="as-negotiation-toggle-btn" @click="negotiationExpanded = !negotiationExpanded">
                    <template v-if="negotiationExpanded">收起 <i class="el-icon-arrow-up" /></template>
                    <template v-else>展开全部（共 {{ negotiationTotal }} 条） <i class="el-icon-arrow-down" /></template>
                  </el-button>
                </div>
              </div>

              <div class="as-card">
                <el-tabs v-model="logisticsTab">
                  <el-tab-pane label="订单物流" name="order">
                    <div class="as-log-block">
                      <p><span class="label">快递公司</span>{{ orderLogistics.company }}</p>
                      <p><span class="label">物流单号</span>{{ orderLogistics.no }}
                        <i class="el-icon-document-copy as-copy" @click="copyText(orderLogistics.no)" /></p>
                      <p><span class="label">发货时间</span>{{ orderLogistics.time }}</p>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="退货物流" name="return" v-if="aftersale.aftersale_type == 0||aftersale.aftersale_type == 3">
                    <div class="as-log-block">
                      <p><span class="label">物流公司</span>{{ returnLogistics.company }}</p>
                      <p><span class="label">物流单号</span>{{ returnLogistics.no }}
                        <i v-if="returnLogistics.no" class="el-icon-document-copy as-copy" @click="copyText(returnLogistics.no)" /></p>
                      <p><span class="label">发货时间</span>{{ returnLogistics.time }}</p>
                      <p class="as-addr"><span class="label">售后地址</span>{{ returnAddressText }}
                        <i v-if="returnAddressText!='-'" class="el-icon-document-copy as-copy" @click="copyText(returnAddressText)" /></p>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="换货物流" name="exchange" v-if="aftersale.aftersale_type == 3">
                    <div class="as-log-block">
                      <p><span class="label">物流公司</span>{{ exchangeLogistics.company }}</p>
                      <p><span class="label">物流单号</span>{{ exchangeLogistics.no }}
                        <i v-if="exchangeLogistics.no" class="el-icon-document-copy as-copy"
                           @click="copyText(exchangeLogistics.no)" />
                      </p>
                      <p><span class="label">发货时间</span>{{ exchangeLogistics.time }}</p>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="as-card" v-if="alibabaAftersale">
                <div class="as-card-hd"><span class="as-card-title">1688售后信息</span></div>
                <div class="as-trade-product as-ali-product" v-if="alibabaProduct">
                  <div
                      class="as-pro-img"
                      :class="{ 'is-link': alibabaProduct.offer_url || alibabaProduct.offer_id }"
                      @click="openAlibabaOfferDetail(alibabaProduct)"
                  >
                    <img v-if="alibabaProduct.img" :src="alibabaProduct.img" alt="" />
                    <div v-else class="as-ph-img" style="width:100%;height:100%"></div>
                  </div>
                  <div class="as-pro-body">
                    <p
                        class="as-pro-title"
                        :class="{ 'is-link': alibabaProduct.offer_url || alibabaProduct.offer_id }"
                        @click="openAlibabaOfferDetail(alibabaProduct)"
                    >{{ alibabaProduct.name || '-' }}</p>
                    <p class="as-pro-spec">{{ alibabaProduct.sku_spec_value || '-' }}</p>
                    <p class="as-pro-meta" v-if="alibabaProduct.offer_id">商品ID：{{ alibabaProduct.offer_id }}</p>
                  </div>
                </div>
                <div class="as-log-block as-ali-info">
                  <p>
                    <span class="label">售后状态</span>{{ alibabaAftersale.refund_status_text || '-' }}
                  </p>
                  <p>
                    <span class="label">售后金额</span>
                    <span class="as-money">¥{{ formatAliAmount(alibabaAftersale.refund_amount) }}</span>
                    <span class="as-ali-amount-sub" v-if="alibabaAftersale.refund_carriage > 0">
											（货款 ¥{{ formatAliAmount(alibabaAftersale.refund_payment) }} + 运费 ¥{{ formatAliAmount(alibabaAftersale.refund_carriage) }}）
										</span>
                  </p>
                  <p>
                    <span class="label">售后数量</span>{{ alibabaAftersale.aftersale_num != null ? alibabaAftersale.aftersale_num + ' 件' : '-' }}
                  </p>
                  <p>
                    <span class="label">售后编号</span>
                    <template v-if="alibabaAftersale.refund_id">
                      <a
                          target="_blank"
                          :href="'https://dispute.1688.com/refund/assureRefundDetail.htm?refundId=' + alibabaAftersale.refund_id"
                      >{{ alibabaAftersale.refund_id }}</a>
                      <i class="el-icon-document-copy as-copy" @click="copyText(String(alibabaAftersale.refund_id))" />
                    </template>
                    <template v-else>-</template>
                  </p>
                  <p v-if="alibabaAftersale.alibaba_order_id">
                    <span class="label">采购单号</span>
                    <a
                        target="_blank"
                        :href="'https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=' + alibabaAftersale.alibaba_order_id"
                    >{{ alibabaAftersale.alibaba_order_id }}</a>
                    <i class="el-icon-document-copy as-copy" @click="copyText(String(alibabaAftersale.alibaba_order_id))" />
                  </p>
                  <p>
                    <span class="label">上家旺旺</span>
                    <span>{{ alibabaAftersale.wangwang_account || '-' }}</span>
                    <i
                        v-if="alibabaAftersale.wangwang_account || alibabaAftersale.wangwang_chat_url"
                        class="el-icon-chat-dot-round as-ali-ww-icon"
                        title="打开旺旺"
                        @click="openAlibabaWangwangChat(alibabaAftersale)"
                    />
                  </p>
                </div>
                <div class="as-ali-ops" v-if="alibabaRefundOperationList.length">
                  <div class="as-ali-ops-hd">退款操作记录</div>
                  <el-timeline>
                    <el-timeline-item
                        v-for="(op, oi) in alibabaRefundOperationListDisplay"
                        :key="'ali-op-' + (op.operation_id || oi) + '-' + (op.gmt_create_time || '')"
                        :timestamp="op.gmt_create_text || ''"
                        placement="top"
                        type="primary"
                    >
                      <p class="as-tl-action">{{ op.operate_remark || op.discription || '操作记录' }}</p>
                      <p class="as-tl-text" v-if="op.discription && op.operate_remark && op.discription !== op.operate_remark">
                        {{ op.discription }}
                      </p>
                      <div class="as-tl-kvs">
                        <p v-if="op.after_operate_status">
                          <em>状态</em>：{{ op.after_operate_status_text || op.after_operate_status }}
                          <template v-if="op.before_operate_status && op.before_operate_status !== op.after_operate_status">
                            （原：{{ op.before_operate_status_text || op.before_operate_status }}）
                          </template>
                        </p>
                        <p v-if="op.operator_login_id"><em>操作人</em>：{{ op.operator_login_id }}</p>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                  <div v-if="alibabaRefundOpsNeedToggle" class="as-negotiation-toggle">
                    <el-button type="text" size="small" class="as-negotiation-toggle-btn" @click="alibabaRefundOpsExpanded = !alibabaRefundOpsExpanded">
                      <template v-if="alibabaRefundOpsExpanded">收起 <i class="el-icon-arrow-up" /></template>
                      <template v-else>展开全部（共 {{ alibabaRefundOperationList.length }} 条） <i class="el-icon-arrow-down" /></template>
                    </el-button>
                  </div>
                </div>
                <div class="as-ali-ops as-ali-ops-empty" v-else-if="alibabaAftersale.refund_id">
                  <div class="as-ali-ops-hd">退款操作记录</div>
                  <p class="as-ali-ops-empty-tip">暂无操作记录</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 售后操作弹窗（拒绝原因 / 凭证） -->
    <el-dialog :title="operateDialogTitle" :visible.sync="operateDialogVisible" width="520px" append-to-body @closed="resetOperateForm">
      <el-form ref="operateFormRef" :model="operateForm" :rules="operateRules" label-width="100px" size="small">
        <el-form-item label="操作类型">
          <span>{{ pendingOperate && pendingOperate.text }}</span>
        </el-form-item>
        <el-form-item label="售后地址" prop="receiver_address_id" v-if="operateNeedReceiverAddress">
          <el-select
              v-model="operateForm.receiver_address_id"
              placeholder="请选择退货地址"
              filterable
              clearable
              style="width: 100%"
              :loading="returnAddressLoading"
          >
            <el-option
                v-for="row in returnAddressList"
                :key="'ra-' + row.dd_address_id"
                :label="returnAddressOptionLabel(row)"
                :value="row.dd_address_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" prop="company_code" v-if="operateNeedExchangeLogistics">
          <el-select v-model="operateForm.company_code" placeholder="请选择快递公司" filterable clearable style="width:100%">
            <el-option v-for="c in logisticsCompanyList" :key="c.code" :label="c.name" :value="c.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" prop="logistics_code" v-if="operateNeedExchangeLogistics">
          <el-input v-model="operateForm.logistics_code" placeholder="请输入换货发货物流单号" clearable />
        </el-form-item>
        <el-form-item label="拒绝原因" prop="reject_reason_code" v-if="operateNeedReject">
          <el-select v-model="operateForm.reject_reason_code" placeholder="请选择" filterable style="width:100%">
            <el-option v-for="r in rejectReasonList" :key="r.reject_reason_code" :label="r.reason" :value="r.reject_reason_code" />
          </el-select>
        </el-form-item>
        <el-form-item label="说明/备注" prop="evidence_content" v-if="operateNeedEvidence">
          <el-input type="textarea" :rows="3" v-model="operateForm.evidence_content" placeholder="将作为抖店备注/凭证说明" />
        </el-form-item>
        <el-form-item label="凭证图片" v-if="operateNeedEvidence">
          <el-upload class="as-upload" :show-file-list="false" :http-request="uploadEvidence" :on-success="onEvidenceUploadOk">
            <div class="as-upload-thumb" v-if="operateForm.evidence_url"><img :src="operateForm.evidence_url" alt="" /></div>
            <i v-else class="el-icon-plus as-upload-plus" />
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
				<el-button @click="operateDialogVisible = false">取消</el-button>
				<el-button
            type="primary"
            :loading="operateSubmitting"
            :disabled="operateConfirmDisabled"
            @click="confirmOperate"
        >确定</el-button>
			</span>
    </el-dialog>

    <AftersaleRemarkDialog
        :visible.sync="remarkDialogVisible"
        :aftersale-id="aftersale ? Number(aftersale.id) : 0"
        :order-id="orderIdForRemarkDialog"
        :initial-tab="remarkDialogInitialTab"
        :initial-remark="remarkInitialForDialog"
        @success="onRemarkDialogSuccess"
    />
    <myFoot />
  </div>
</template>

<script>
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import AftersaleRemarkDialog from './components/AftersaleRemarkDialog.vue';
import { mapActions } from 'vuex';
import { createDirectUploadRequest } from '../../assets/js/utils/ossDirectUpload';

/** 与接口文档 AfterSales 抖店节点一致的部分取值（退货退款主流程） */
const DD_STATUS = {
  WAIT_SELLER_PASS: 6,
  WAIT_BUYER_RETURN: 7,
  WAIT_SELLER_AGAIN: 11,
  SUCCESS: 12
};

const PLACEHOLDER = {
  orderTime: '2026-04-26 12:36:42',
  productTitle: 'Klein blue 速干短袖T恤（示例商品名）',
  productId: '3815615088765829132',
  spec: '颜色：红色常规；尺码：XL；商家编码：4364509744908',
  timeline: [
    '【示例】消费者：发起了退货退款申请…',
    '【示例】系统：因该用户信誉良好，系统自动同意退货申请',
    '【示例】系统：预约驿站寄件成功'
  ]
};

/** 协商记录收起时最多展示的条数（展示时间轴末尾最新几条） */
const NEGOTIATION_PREVIEW_LEN = 3;

/** 延长收货入口：距截止时间剩余小于此时长才展示（秒） */
const EXTEND_RECEIPT_MAX_REMAIN_SEC = 2 * 86400;

export default {
  name: 'UcAfterSalesDetail',
  components: { myHead, myFoot, AftersaleRemarkDialog },
  data() {
    return {
      PLACEHOLDER,
      pageLoading: false,
      loadError: '',
      aftersale: null,
      operateList: [],
      orderDetail: null,
      orderProduct: null,
      countdownTimer: null,
      countdownText: '',
      logisticsTab: 'order',
      operateDialogVisible: false,
      pendingOperate: null,
      operateForm: {
        reject_reason_code: '',
        evidence_content: '',
        evidence_url: '',
        receiver_address_id: '',
        company_code: '',
        logistics_code: ''
      },
      operateSubmitting: false,
      returnAddressList: [],
      returnAddressLoading: false,
      rejectReasonList: [],
      logisticsCompanyList: [],
      primaryOperateVals: [111, 201, 101, 301, 121, 311],
      negotiationExpanded: false,
      remarkDialogVisible: false,
      remarkDialogInitialTab: 'aftersale',
      extendReceiptSubmitting: false,
      logisticsInterceptSubmitting: false,
      aftersaleProcessList: [],
      processFlowStatus: '',
      processCurrentKey: null,
      alibabaOrderRefundId: '',
      alibabaOrderRefundStatusText: '',
      alibabaAftersale: null,
      alibabaRefundOperationList: [],
      alibabaRefundOpsExpanded: false
    };
  },
  computed: {
    afterId() {
      const q = this.$route.query.id;
      const id = parseInt(q, 10);
      return Number.isFinite(id) ? id : 0;
    },
    textPart() {
      const tp = this.aftersale && this.aftersale.text_part;
      if (!tp || typeof tp !== 'object' || Array.isArray(tp)) return {};
      return tp;
    },
    recordLogs() {
      const r = this.aftersale && this.aftersale.record_logs_list;
      return Array.isArray(r) ? r : [];
    },
    timelineRecords() {
      return this.recordLogs;
    },
    negotiationTotal() {
      const n = this.timelineRecords.length;
      return n > 0 ? n : PLACEHOLDER.timeline.length;
    },
    negotiationNeedToggle() {
      return this.negotiationTotal > NEGOTIATION_PREVIEW_LEN;
    },
    /** 收起时仅展示末尾若干条，便于先看最新节点 */
    timelineRecordsDisplay() {
      const list = this.timelineRecords;
      if (!list.length) return [];
      if (this.negotiationExpanded || list.length <= NEGOTIATION_PREVIEW_LEN) return list;
      return list.slice(-NEGOTIATION_PREVIEW_LEN);
    },
    placeholderTimelineDisplay() {
      const arr = PLACEHOLDER.timeline;
      if (this.negotiationExpanded || arr.length <= NEGOTIATION_PREVIEW_LEN) return arr;
      return arr.slice(-NEGOTIATION_PREVIEW_LEN);
    },
    alibabaRefundOpsNeedToggle() {
      return this.alibabaRefundOperationList.length > NEGOTIATION_PREVIEW_LEN;
    },
    /** 接口已按时间倒序（最新在前），收起时保留前几条最新记录 */
    alibabaRefundOperationListDisplay() {
      const list = this.alibabaRefundOperationList;
      if (!list.length) return [];
      if (this.alibabaRefundOpsExpanded || list.length <= NEGOTIATION_PREVIEW_LEN) return list;
      return list.slice(0, NEGOTIATION_PREVIEW_LEN);
    },
    statusHeadline() {
      return this.textPart.aftersale_status_text || '售后处理';
    },
    typeTagText() {
      return this.textPart.aftersale_type_text || '退货退款';
    },
    reasonText() {
      return this.textPart.reason_text || '-';
    },
    applyTimeText() {
      return this.aftersale.apply_time_text || this.aftersale.apply_time || '-';
    },
    shopOrderId() {
      return this.aftersale ? String(this.aftersale.shop_order_id || '') : '';
    },
    showAlibabaOrderRefundInfo() {
      const id = this.alibabaOrderRefundId;
      return id != null && String(id).trim() !== '';
    },
    alibabaProduct() {
      const a = this.alibabaAftersale;
      return a && a.product && typeof a.product === 'object' ? a.product : null;
    },
    orderCreateTime() {
      return this.orderDetail && this.orderDetail.create_time;
    },
    stepActiveIndex() {
      const st = this.aftersale ? Number(this.aftersale.aftersale_status) : 0;
      const tp = this.aftersale ? Number(this.aftersale.aftersale_type) : 0;
      if (tp !== 0) {
        if (st === DD_STATUS.WAIT_SELLER_PASS) return 1;
        if (st === DD_STATUS.WAIT_BUYER_RETURN) return 2;
        if (st === DD_STATUS.WAIT_SELLER_AGAIN) return 3;
        if (st === DD_STATUS.SUCCESS) return 4;
        if (st > DD_STATUS.SUCCESS) return 4;
      }
      return 3;
    },
    sortedProcessSteps() {
      const list = this.aftersaleProcessList;
      if (!Array.isArray(list) || !list.length) return [];
      return [...list].sort((a, b) => (Number(a.step_no) || 0) - (Number(b.step_no) || 0));
    },
    processStepsActiveIndex() {
      const list = this.sortedProcessSteps;
      if (!list.length) return this.stepActiveIndex;
      const activeIdx = list.findIndex((s) => s.step_status === 'active');
      if (activeIdx >= 0) return activeIdx;
      const failedIdx = list.findIndex((s) => s.step_status === 'failed');
      if (failedIdx >= 0) return failedIdx;
      const allCompleted = list.length > 0 && list.every((s) => s.step_status === 'completed');
      if (allCompleted) return list.length;
      const pendIdx = list.findIndex((s) => s.step_status === 'pending');
      if (pendIdx > 0) return pendIdx - 1;
      return 0;
    },
    /** 横向步骤条数据：接口流程或本地退货退款模板 */
    processStepBarList() {
      const api = this.sortedProcessSteps;
      if (Array.isArray(api) && api.length) {
        return api.map((step, idx) => {
          const st = step.step_status;
          let uiState = 'wait';
          if (st === 'completed') uiState = 'done';
          else if (st === 'active') uiState = 'current';
          else if (st === 'failed') uiState = 'error';
          else if (st === 'pending') uiState = 'wait';
          return {
            key: String(step.key || step.step_no || idx) + '-' + idx,
            title: step.title || '步骤' + (Number(step.step_no) || idx + 1),
            uiState
          };
        });
      }
      const titles = ['用户申请退货', '同意申请', '买家寄回', '退款成功', '售后完成'];
      const act = this.stepActiveIndex;
      const st = this.aftersale ? Number(this.aftersale.aftersale_status) : 0;
      const allDone = st === DD_STATUS.SUCCESS || st > DD_STATUS.SUCCESS;
      return titles.map((title, idx) => {
        let uiState = 'wait';
        if (allDone) uiState = 'done';
        else if (idx < act) uiState = 'done';
        else if (idx === act) uiState = 'current';
        return {
          key: 'tpl-' + idx,
          title,
          uiState
        };
      });
    },
    processFlowStatusLabel() {
      const s = this.processFlowStatus;
      if (!s) return '';
      const map = {
        processing: '进行中',
        success: '已成功完结',
        failed: '失败 / 已关闭'
      };
      return map[s] || s;
    },
    processFlowTagType() {
      const s = this.processFlowStatus;
      if (s === 'success') return 'success';
      if (s === 'failed') return 'danger';
      return 'info';
    },
    processCurrentKeyDisplay() {
      const k = this.processCurrentKey;
      if (k === null || k === undefined || k === '') return '';
      const hit = this.sortedProcessSteps.find((s) => s.key === k);
      return hit && hit.title ? `${hit.title}（${k}）` : String(k);
    },
    showExtendReceiptStub() {
      const a = this.aftersale;
      if (!a) return false;
      if (Number(a.aftersale_status) !== DD_STATUS.WAIT_SELLER_AGAIN) return false;
      let ts = parseInt(a.status_deadline, 10);
      if (!ts || ts <= 0) return false;
      if (ts > 1e12) ts = Math.floor(ts / 1000);
      const nowSec = Math.floor(Date.now() / 1000);
      if (ts <= nowSec) return false;
      const remaining = ts - nowSec;
      return remaining > 0 && remaining < EXTEND_RECEIPT_MAX_REMAIN_SEC;
    },
    /** 已发货仅退款（aftersale_type=1）：展示物流拦截入口，与「订单已发货 + 仅退款」一致 */
    showLogisticsInterceptUi() {
      const a = this.aftersale;
      if (!a) return false;
      return Number(a.aftersale_type) === 1 && (Number(a.aftersale_status) === DD_STATUS.WAIT_SELLER_PASS);
    },
    logisticsInterceptStateNum() {
      const a = this.aftersale;
      if (!a) return 0;
      const s = Number(a.logistics_intercept_state);
      return Number.isNaN(s) ? 0 : s;
    },
    logisticsInterceptStatusText() {
      const map = {
        1: '物流拦截中',
        2: '物流拦截成功',
        3: '物流拦截失败'
      };
      const n = this.logisticsInterceptStateNum;
      if (map[n]) return map[n];
      if (n > 0) return `物流拦截状态(${n})`;
      return '';
    },
    logisticsInterceptTagType() {
      const n = this.logisticsInterceptStateNum;
      if (n === 1) return 'warning';
      if (n === 2) return 'success';
      if (n === 3) return 'danger';
      return 'info';
    },
    consumerRefundText() {
      const a = this.aftersale;
      if (!a) return '-';
      const post = Number(a.refund_post_amount);
      const total = Number(a.refund_amount);
      if (!Number.isNaN(post) && !Number.isNaN(total)) {
        const v = Math.max(0, total - post);
        return this.formatYuan(v);
      }
      return this.formatYuan(a.refund_amount);
    },
    receiptStatusText() {
      return this.textPart.return_logistics_text || this.textPart.logistics_text || '-';
    },
    returnNumText() {
      if (this.aftersale && this.aftersale.return_logistics_code) {
        return (this.aftersale.aftersale_num != null ? this.aftersale.aftersale_num : '1') + ' 件';
      }
      return '-';
    },
    buyerRemark() {
      return this.aftersale && this.aftersale.remark;
    },
    remarkInitialForDialog() {
      const r = this.aftersale && this.aftersale.remark;
      return r != null && r !== '' ? String(r) : '';
    },
    /** 主订单 id，用于订单备注弹窗与接口 */
    orderIdForRemarkDialog() {
      const oid = this.aftersale && this.aftersale.order_id;
      if (oid == null || oid === '') return 0;
      const n = Number(oid);
      return Number.isFinite(n) ? n : 0;
    },
    /** 列表/详情中的订单备注文案 */
    orderDetailSellerWordsDisplay() {
      const w = this.orderDetail && this.orderDetail.seller_words;
      if (w == null || String(w).trim() === '') return '暂无';
      return String(w);
    },
    /** 是否展示订单旗子（有颜色信息或曾选过星标时展示） */
    orderSellerRemarkFlagShow() {
      const d = this.orderDetail;
      if (!d) return false;
      if (d.seller_remark_starts_info && typeof d.seller_remark_starts_info === 'object') return true;
      if (d.seller_remark_stars != null && d.seller_remark_stars !== '') return true;
      return false;
    },
    orderSellerRemarkFlagColor() {
      const d = this.orderDetail;
      if (!d) return '#c0c4cc';
      const info = d.seller_remark_starts_info;
      if (info && typeof info === 'object' && info.color) return info.color;
      return '#c0c4cc';
    },
    evidenceStub() {
      return '-';
    },
    merchantRemark() {
      return '';
    },
    shipStatusText() {
      return this.textPart.logistics_text || '1/1 已发货（示例）';
    },
    userPaidText() {
      if (this.orderDetail && this.orderDetail.pay_amount != null) {
        return '￥' + this.orderDetail.pay_amount;
      }
      return this.formatYuan(this.aftersale && this.aftersale.refund_amount);
    },
    orderLogistics() {
      const d = this.orderDetail;
      const stub = { company: '中通快递（示例）', no: '73708741610942', time: '2026-05-03 18:07:09' };
      if (!d) return stub;
      const del = (d.supplier_order_delivery && d.supplier_order_delivery[0]) || {};
      if (del.company || del.logistics_code) {
        return {
          company: del.company || '-',
          no: del.logistics_code || '-',
          time: del.update_time || '-'
        };
      }
      if (d.dd_order_print) {
        return {
          company: d.dd_order_print.logistics_company || '-',
          no: d.dd_order_print.track_no || '-',
          time: '-'
        };
      }
      return stub;
    },
    returnLogistics() {
      const a = this.aftersale;
      if (!a) return { company: '-', no: '', time: '-' };
      return {
        company: a.return_logistics_company_name || '-',
        no: a.return_logistics_code || '',
        time: a.return_logistics_time_text || '-'
      };
    },
    exchangeLogistics() {
      const a = this.aftersale;
      if (!a) return { company: '-', no: '', time: '-' };
      return {
        company: a.exchange_logistics_company_name || '-',
        no: a.exchange_logistics_code || '',
        time: a.exchange_logistics_time_text || '-'
      };
    },
    returnAddressText() {
      const a = this.aftersale;
      if (a && a.return_address) return this.extractReturnAddress(a.return_address);
      const fromKv = this.extractReturnAddressFromLogs();
      return fromKv || '-';
    },
    operateRules() {
      const vm = this;
      return {
        reject_reason_code: [
          {
            validator(rule, v, cb) {
              if (!vm.operateNeedReject) return cb();
              if (v === '' || v == null) cb(new Error('请选择拒绝原因'));
              else cb();
            },
            trigger: 'change'
          }
        ],
        evidence_content: [
          {
            validator(rule, v, cb) {
              if (!vm.operateNeedEvidence) return cb();
              if (!v || !String(v).trim()) cb(new Error('请填写说明'));
              else cb();
            },
            trigger: 'blur'
          }
        ],
        receiver_address_id: [
          {
            validator(rule, v, cb) {
              if (!vm.operateNeedReceiverAddress) return cb();
              if (vm.returnAddressLoading) return cb();
              if (!vm.returnAddressList.length) return cb();
              if (v === '' || v == null) cb(new Error('请选择售后退货地址'));
              else cb();
            },
            trigger: 'change'
          }
        ],
        company_code: [
          {
            validator(rule, v, cb) {
              if (!vm.operateNeedExchangeLogistics) return cb();
              if (v === '' || v == null) cb(new Error('请选择快递公司'));
              else cb();
            },
            trigger: 'change'
          }
        ],
        logistics_code: [
          {
            validator(rule, v, cb) {
              if (!vm.operateNeedExchangeLogistics) return cb();
              if (!v || !String(v).trim()) cb(new Error('请填写物流单号'));
              else cb();
            },
            trigger: 'blur'
          }
        ]
      };
    },
    operateConfirmDisabled() {
      return this.operateNeedReceiverAddress && this.returnAddressLoading;
    },
    operateDialogTitle() {
      return this.pendingOperate ? `确认操作：${this.pendingOperate.text}` : '售后操作';
    },
    operateNeedReject() {
      return this.opOther(this.pendingOperate).includes('reject_reason_code');
    },
    operateNeedEvidence() {
      return this.opOther(this.pendingOperate).includes('evidence');
    },
    operateNeedReceiverAddress() {
      return this.opOther(this.pendingOperate).includes('Logistics.ReceiverAddressId');
    },
    operateNeedExchangeLogistics() {
      const other = this.opOther(this.pendingOperate);
      return other.includes('logistics.companyCode') || other.includes('logistics.logisticsCode');
    }
  },
  created() {
    this.bootstrap();
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },
  methods: {
    ...mapActions({
      getDdAftersaleDetail: 'ucenter_order/getDdAftersaleDetail',
      opDdAftersaleOperate: 'ucenter_order/opDdAftersaleOperate',
      opDdAftersaleTimeExtend: 'ucenter_order/opDdAftersaleTimeExtend',
      opDdAftersaleApplyLogisticsIntercept: 'ucenter_order/opDdAftersaleApplyLogisticsIntercept',
      getDdReturnAddressList: 'ucenter_order/getDdReturnAddressList',
      getOrderManageDetail: 'ucenter_order/getOrderManageDetail',
      getOrderServerGetOperateInfo: 'ucenter_order/getOrderServerGetOperateInfo'
    }),
    opOther(op) {
      return Array.isArray(op && op.other) ? op.other : [];
    },
    syncProcessFromDetail(data) {
      const d = data || {};
      this.aftersaleProcessList = Array.isArray(d.aftersale_process_list) ? d.aftersale_process_list : [];
      this.processFlowStatus = d.process_flow_status || '';
      this.processCurrentKey = Object.prototype.hasOwnProperty.call(d, 'process_current_key')
          ? d.process_current_key
          : null;
    },
    syncAlibabaOrderRefundFromDetail(data) {
      const d = data || {};
      const ali = d.alibaba_aftersale && typeof d.alibaba_aftersale === 'object' ? d.alibaba_aftersale : null;
      this.alibabaAftersale = ali;
      this.alibabaRefundOperationList = Array.isArray(d.alibaba_refund_operation_list)
          ? d.alibaba_refund_operation_list
          : [];
      this.alibabaRefundOpsExpanded = false;
      if (ali) {
        this.alibabaOrderRefundId = ali.refund_id != null ? String(ali.refund_id) : '';
        this.alibabaOrderRefundStatusText = ali.refund_status_text != null
            ? String(ali.refund_status_text)
            : '';
        return;
      }
      this.alibabaOrderRefundId = d.alibaba_order_refund_id != null ? String(d.alibaba_order_refund_id) : '';
      this.alibabaOrderRefundStatusText = d.alibaba_order_refund_status_text != null
          ? String(d.alibaba_order_refund_status_text)
          : '';
    },
    formatAliAmount(v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return '0.00';
      return n.toFixed(2);
    },
    openAlibabaWangwangChat(ali) {
      const row = ali || this.alibabaAftersale || {};
      const url = String(row.wangwang_chat_url || '').trim();
      if (url) {
        window.open(url, '_blank');
        return;
      }
      const account = String(row.wangwang_account || '').trim();
      if (!account) {
        this.$message({ message: '暂无上家旺旺', type: 'warning' });
        return;
      }
      const wangwangId = account.replace(/^cnalichn/i, '');
      const touid = encodeURIComponent('cnalichn' + wangwangId);
      window.open(
          `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`,
          '_blank'
      );
    },
    openAlibabaOfferDetail(product) {
      const p = product || this.alibabaProduct || {};
      let url = String(p.offer_url || '').trim();
      if (!url && p.offer_id) {
        const id = String(p.offer_id).trim();
        url = `https://detail.1688.com/offer/${id}.html?offerId=${id}`;
      }
      if (!url) {
        this.$message({ message: '暂无1688商品链接', type: 'warning' });
        return;
      }
      window.open(url, '_blank');
    },
    bootstrap() {
      if (!this.afterId) {
        this.loadError = '缺少售后记录 id';
        return;
      }
      this.pageLoading = true;
      this.loadError = '';
      this.getDdAftersaleDetail({
        data: { id: this.afterId },
        success: (res) => {
          if (res.code !== 200) {
            this.loadError = res.msg || '加载失败';
            this.pageLoading = false;
            return;
          }
          const data = res.data || {};
          this.aftersale = data.aftersale || null;
          this.operateList = data.operate_type_list || [];
          this.logisticsCompanyList = Array.isArray(data.logistics_company_list) ? data.logistics_company_list : [];
          this.syncProcessFromDetail(data);
          this.syncAlibabaOrderRefundFromDetail(data);
          this.negotiationExpanded = false;
          if (!this.aftersale) {
            this.loadError = '数据为空';
            this.pageLoading = false;
            return;
          }
          this.startCountdown();
          this.fetchOrderDetail();
          this.pageLoading = false;
        }
      });
    },
    openRemarkDialog(tab = 'aftersale') {
      if (!this.aftersale || !this.aftersale.id) {
        this.$message.warning('售后数据未就绪');
        return;
      }
      this.remarkDialogInitialTab = tab === 'order' ? 'order' : 'aftersale';
      this.remarkDialogVisible = true;
    },
    onRemarkDialogSuccess() {
      this.refreshAftersaleDetail();
      this.fetchOrderDetail();
    },
    confirmExtendReceipt() {
      if (!this.aftersale || !this.aftersale.id) {
        this.$message.warning('售后数据未就绪');
        return;
      }
      if (!this.showExtendReceiptStub) return;
      this.$confirm('确认向抖店申请延长售后收货时限？', '延长收货', {
        type: 'warning',
        confirmButtonText: '确认延长',
        cancelButtonText: '取消'
      })
          .then(() => {
            if (this.extendReceiptSubmitting) return;
            this.extendReceiptSubmitting = true;
            this.opDdAftersaleTimeExtend({
              data: { id: this.aftersale.id },
              success: (res) => {
                this.extendReceiptSubmitting = false;
                if (res.code === 200) {
                  this.$message.success(res.msg || '申请成功');
                  this.refreshAftersaleDetail();
                } else {
                  this.$message.error(res.msg || '申请失败');
                }
              }
            });
          })
          .catch(() => {});
    },
    confirmApplyLogisticsIntercept() {
      if (!this.aftersale || !this.aftersale.id) {
        this.$message.warning('售后数据未就绪');
        return;
      }
      if (this.logisticsInterceptStateNum !== 0) return;
      this.$confirm('确认向抖店申请物流拦截？将按当前子订单发货运单发起拦截。', '申请物流拦截', {
        type: 'warning',
        confirmButtonText: '确认申请',
        cancelButtonText: '取消'
      })
          .then(() => {
            if (this.logisticsInterceptSubmitting) return;
            this.logisticsInterceptSubmitting = true;
            this.opDdAftersaleApplyLogisticsIntercept({
              data: { id: this.aftersale.id },
              success: (res) => {
                this.logisticsInterceptSubmitting = false;
                if (res.code === 200) {
                  this.$message.success(res.msg || '申请已提交');
                  this.refreshAftersaleDetail();
                } else {
                  this.$message.error(res.msg || '申请失败');
                }
              }
            });
          })
          .catch(() => {});
    },
    refreshAftersaleDetail() {
      if (!this.afterId) return;
      this.getDdAftersaleDetail({
        data: { id: this.afterId },
        success: (res) => {
          if (res.code !== 200 || !res.data) return;
          this.aftersale = res.data.aftersale || this.aftersale;
          this.operateList = res.data.operate_type_list || this.operateList;
          if (Array.isArray(res.data.logistics_company_list)) {
            this.logisticsCompanyList = res.data.logistics_company_list;
          }
          this.syncProcessFromDetail(res.data);
          this.syncAlibabaOrderRefundFromDetail(res.data);
          this.negotiationExpanded = false;
          if (this.aftersale) {
            this.startCountdown();
          }
        }
      });
    },
    fetchOrderDetail() {
      const oid = this.aftersale && this.aftersale.order_id;
      if (!oid) return;
      this.getOrderManageDetail({
        data: { order_id: oid },
        success: (res) => {
          if (res.code !== 200 || !res.data) return;
          this.orderDetail = res.data;
          const pid = this.aftersale.order_product_id;
          const list = res.data.order_product || [];
          const row = list.find((p) => p.id == pid) || list[0];
          this.orderProduct = row || null;
        }
      });
    },
    extractReturnAddress(return_address) {
      var str_address = return_address['name']+ " " + return_address['phone'] + " \n\r" + return_address['province'] + return_address['city'] + return_address['town'] + return_address['street'] + return_address['detail'];
      return str_address;
    },
    extractReturnAddressFromLogs() {
      for (const rec of this.recordLogs) {
        const kvs = rec.desc_kvs || [];
        const hit = kvs.find((k) => k.key && String(k.key).indexOf('退货地址') !== -1);
        if (hit && hit.value) return hit.value;
      }
      return '';
    },
    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownText = '';
      const raw = this.aftersale && this.aftersale.status_deadline;
      const ts = parseInt(raw, 10);
      if (!ts || ts <= 0) return;
      const endMs = ts < 1e12 ? ts * 1000 : ts;
      const tick = () => {
        const left = Math.floor((endMs - Date.now()) / 1000);
        if (left <= 0) {
          this.countdownText = '00 秒';
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          return;
        }
        const d = Math.floor(left / 86400);
        const restAfterDay = left % 86400;
        const h = Math.floor(restAfterDay / 3600);
        const m = Math.floor((restAfterDay % 3600) / 60);
        const s = restAfterDay % 60;
        const parts = [];
        if (d > 0) parts.push(`${d} 天`);
        if (d > 0 || h > 0) parts.push(`${h} 小时`);
        parts.push(`${m} 分`, `${s} 秒`);
        this.countdownText = parts.join(' ');
      };
      tick();
      this.countdownTimer = setInterval(tick, 1000);
    },
    formatYuan(v) {
      if (v === '' || v == null) return '-';
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return '￥' + n.toFixed(2);
    },
    copyText(text) {
      if (!text) return;
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message.success('已复制');
    },
    /** 协商记录 all_evidence：多条凭证，每条含 urls、可选 desc */
    negotiationEvidenceBlocks(rec) {
      const raw = rec && rec.all_evidence;
      if (!Array.isArray(raw) || !raw.length) return [];
      const blocks = [];
      for (const ev of raw) {
        if (!ev || typeof ev !== 'object') continue;
        let urls = [];
        if (Array.isArray(ev.urls)) {
          urls = ev.urls.map((u) => (u == null ? '' : String(u).trim())).filter(Boolean);
        } else if (ev.url) {
          urls = [String(ev.url).trim()].filter(Boolean);
        }
        const desc = ev.desc != null && String(ev.desc).trim() !== '' ? String(ev.desc).trim() : '';
        if (!urls.length && !desc) continue;
        blocks.push({ desc, urls });
      }
      return blocks;
    },
    negotiationEvidenceAllUrls(rec) {
      return this.negotiationEvidenceBlocks(rec).reduce((acc, b) => acc.concat(b.urls), []);
    },
    defaultExchangeLogisticsForm() {
      const a = this.aftersale || {};
      const d = this.orderDetail || {};
      const print = d.dd_order_print || {};
      let companyCode = a.exchange_logistics_company_code || print.logistics_code || '';
      if (companyCode && this.logisticsCompanyList.length) {
        const hit = this.logisticsCompanyList.find((c) => String(c.code) === String(companyCode));
        if (!hit) companyCode = '';
      }
      return {
        company_code: companyCode,
        logistics_code: a.exchange_logistics_code || ''
      };
    },
    openOperate(op) {
      const other = this.opOther(op);
      const needForm =
          other.includes('reject_reason_code') ||
          other.includes('evidence') ||
          other.includes('Logistics.ReceiverAddressId') ||
          other.includes('logistics.companyCode') ||
          other.includes('logistics.logisticsCode');
      if (!needForm) {
        this.$confirm(`确认执行「${op.text}」？`, '提示', { type: 'warning' })
            .then(() => this.submitOperate(op, {}))
            .catch(() => {});
        return;
      }
      this.pendingOperate = op;
      this.returnAddressList = [];
      const exchangeLogistics = this.defaultExchangeLogisticsForm();
      this.operateForm = {
        reject_reason_code: '',
        evidence_content: '',
        evidence_url: '',
        receiver_address_id: '',
        company_code: exchangeLogistics.company_code,
        logistics_code: exchangeLogistics.logistics_code
      };
      this.operateDialogVisible = true;
      if (other.includes('reject_reason_code')) {
        this.prefetchRejectReasons();
      }
      if (other.includes('Logistics.ReceiverAddressId')) {
        this.fetchReturnAddressList();
      }
      this.$nextTick(() => this.$refs.operateFormRef && this.$refs.operateFormRef.clearValidate());
    },
    fetchReturnAddressList() {
      const a = this.aftersale;
      if (!a || a.id == null) return;
      this.returnAddressLoading = true;
      this.getDdReturnAddressList({
        data: { id: a.id },
        success: (res) => {
          this.returnAddressLoading = false;
          if (res.code !== 200) {
            this.$message.error(res.msg || '加载退货地址失败');
            return;
          }
          const list = (res.data && res.data.address_list) || [];
          this.returnAddressList = Array.isArray(list) ? list : [];
          const rid = a.return_address_id;
          const notZero =
              rid != null &&
              rid !== '' &&
              rid !== 0 &&
              String(rid) !== '0';
          if (notZero) {
            const hit = this.returnAddressList.find((x) => String(x.dd_address_id) === String(rid));
            if (hit) this.operateForm.receiver_address_id = hit.dd_address_id;
          }
          this.$nextTick(() => {
            this.$refs.operateFormRef && this.$refs.operateFormRef.clearValidate('receiver_address_id');
          });
        }
      });
    },
    returnAddressOptionLabel(row) {
      if (!row || typeof row !== 'object') return '';
      let base = '';
      if (row.full_name != null && String(row.full_name).trim()) {
        base = String(row.full_name).trim();
      } else {
        try {
          base = this.extractReturnAddress(row);
        } catch (e) {
          base = '';
        }
      }
      if (!base) base = row.dd_address_id != null ? String(row.dd_address_id) : '';
      const tagText =
          row.tag === 1 ? '当前订单' : row.tag === 2 ? '当前商品策略' : row.tag === 3 ? '抖店售后地址' : '';
      return tagText ? `${base} [${tagText}]` : base;
    },
    prefetchRejectReasons() {
      const a = this.aftersale;
      if (!a) return;
      this.getOrderServerGetOperateInfo({
        data: { order_id: a.order_id, aftersale_id: a.aftersale_id },
        success: (res) => {
          if (res.code === 200) {
            this.rejectReasonList = res.data.reject_reason_list || [];
          }
        }
      });
    },
    onEvidenceUploadOk(res) {
      if (res.code == 200) this.operateForm.evidence_url = res.data.address|| res.data.url;
      else this.$message.error(res.msg || '上传失败');
    },
    uploadEvidence(options) {
      createDirectUploadRequest(options, { purpose: 'merchant_image' });
    },
    resetOperateForm() {
      this.pendingOperate = null;
      this.returnAddressList = [];
      this.returnAddressLoading = false;
      this.operateForm = {
        reject_reason_code: '',
        evidence_content: '',
        evidence_url: '',
        receiver_address_id: '',
        company_code: '',
        logistics_code: ''
      };
    },
    confirmOperate() {
      this.$refs.operateFormRef.validate((valid) => {
        if (!valid) return;
        this.submitOperate(this.pendingOperate, {
          reject_reason_code: this.operateForm.reject_reason_code,
          evidence_content: this.operateForm.evidence_content,
          evidence_url: this.operateForm.evidence_url,
          receiver_address_id: this.operateForm.receiver_address_id,
          company_code: this.operateForm.company_code,
          logistics_code: this.operateForm.logistics_code
        });
      });
    },
    submitOperate(op, extra) {
      if (!op || !this.aftersale) return;
      if (this.operateSubmitting) return;
      const payload = {
        id: this.aftersale.id,
        type: op.val,
        evidence_content: extra.evidence_content || '',
        evidence_url: extra.evidence_url || ''
      };
      if (this.opOther(op).includes('reject_reason_code')) {
        payload.reject_reason_code = extra.reject_reason_code;
      }
      if (
          this.opOther(op).includes('Logistics.ReceiverAddressId') &&
          extra.receiver_address_id !== '' &&
          extra.receiver_address_id != null
      ) {
        payload.receiver_address_id = extra.receiver_address_id;
      }
      const other = this.opOther(op);
      if (other.includes('logistics.companyCode') || other.includes('logistics.logisticsCode')) {
        payload.company_code = extra.company_code;
        payload.logistics_code = String(extra.logistics_code || '').trim();
      }
      this.operateSubmitting = true;
      this.opDdAftersaleOperate({
        data: payload,
        success: (res) => {
          this.operateSubmitting = false;
          if (res.code === 200) {
            this.$message.success(res.msg || '操作成功');
            this.operateDialogVisible = false;
            this.pageLoading = true;
            this.getDdAftersaleDetail({
              data: { id: this.afterId },
              success: (r2) => {
                this.pageLoading = false;
                if (r2.code === 200) {
                  this.aftersale = r2.data.aftersale;
                  this.operateList = r2.data.operate_type_list || [];
                  this.syncProcessFromDetail(r2.data);
                  this.syncAlibabaOrderRefundFromDetail(r2.data);
                  this.negotiationExpanded = false;
                  this.startCountdown();
                }
              }
            });
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.as-detail-page {
  min-height: 70vh;
  background: #f5f6f8;
}
.as-detail-center {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 40px;
  box-sizing: border-box;
  width: 100%;
}
.page_links {
  line-height: 1;
  font-size: 14px;
  color: #999;
  display: flex;
  margin: 20px 0 16px;
}
.as-detail-error {
  background: #fff;
  padding: 40px;
  text-align: center;
  border-radius: 8px;
}
.as-detail-layout {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.as-detail-main {
  flex: 1;
  min-width: 0;
  position: sticky;
  top: 98px;
  align-self: flex-start;
  z-index: 5;
  max-height: calc(100vh - 98px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.as-detail-side {
  width: 340px;
  flex-shrink: 0;
}
.as-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.as-card-hd {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  gap: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.as-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.as-status-card .as-steps-inner {
  margin: -4px 0 4px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}
.as-step-bar {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 6px 0 8px;
}
.as-step-bar-cell {
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
}
.as-step-bar-cell:last-child {
  flex: 0 0 auto;
}
.as-step-bar-seg {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  min-width: 0;
}
.as-step-bar-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  line-height: 1;
  box-sizing: border-box;
}
.as-step-bar-seg--done .as-step-bar-icon {
  background: #fde2e2;
  color: #f0413e;
  border: 1px solid #fde2e2;
}
.as-step-bar-seg--current .as-step-bar-icon {
  background: #f0413e;
  color: #fff;
  border: 1px solid #f0413e;
}
.as-step-bar-seg--error .as-step-bar-icon {
  background: #fde2e2;
  color: #f56c6c;
  border: 1px solid #fab6b6;
}
.as-step-bar-seg--wait .as-step-bar-icon {
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  color: #c0c4cc;
}
.as-step-bar-dot-inner {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
}
.as-step-bar-seg--wait .as-step-bar-dot-inner.is-muted {
  width: 6px;
  height: 6px;
  background: #dcdfe6;
}
.as-step-bar-title {
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
}
.as-step-bar-seg--wait .as-step-bar-title {
  color: #909399;
}
.as-step-bar-line {
  flex: 1 1 12px;
  min-width: 12px;
  height: 0;
  margin: 0 6px 0 8px;
  border-top: 1px dotted #fde2e2;
  align-self: center;
}
.as-process-flow-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-bottom: 18px;
  font-size: 13px;
  color: #606266;
}
.as-process-flow-label {
  color: #909399;
}
.as-process-current-key {
  color: #909399;
  font-size: 12px;
}
.as-status-card .as-status-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px;
}
.as-countdown {
  font-size: 13px;
  color: #666;
  margin: 0 0 16px;
  line-height: 1.6;
}
.as-countdown--muted {
  color: #999;
}
.as-countdown-num {
  color: var(--red, #f0413e);
  font-weight: 600;
}
.as-action-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.as-op-btn.el-button--primary {
  background: #1966ff;
  border-color: #1966ff;
}
.as-remark-line {
  font-size: 13px;
  color: #666;
  margin: 0;
}
.as-remark-line--order {
  margin-bottom: 8px;
}
.as-remark-k {
  color: #909399;
  margin-right: 4px;
}
.as-remark-val {
  color: #333;
  word-break: break-all;
}
.as-order-flag {
  font-size: 15px;
  margin-right: 6px;
  vertical-align: -1px;
}
.as-link-muted {
  color: #1966ff;
  margin-left: 6px;
}
.as-info-grid {
  font-size: 13px;
  color: #333;
}
.as-info-row {
  display: grid;
  grid-template-columns: 100px 1fr 100px 1fr;
  gap: 10px 12px;
  align-items: start;
  margin-bottom: 12px;
}
.as-info-row .label {
  color: #999;
}
.as-info-row .val {
  word-break: break-all;
}
.as-money {
  color: var(--red, #f0413e);
  font-weight: 600;
}
.as-copy {
  cursor: pointer;
  color: #1966ff;
  margin-left: 6px;
}
.as-info-block p {
  margin: 8px 0;
  line-height: 1.6;
}
.as-info-block .label {
  display: inline-block;
  min-width: 100px;
  color: #999;
}
.as-trade-product {
  display: flex;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}
.as-ali-product {
  margin-bottom: 8px;
}
.as-ali-product .as-pro-img.is-link,
.as-ali-product .as-pro-title.is-link {
  cursor: pointer;
}
.as-ali-product .as-pro-title.is-link:hover {
  color: #1966ff;
}
.as-ali-info {
  padding-top: 4px;
}
.as-ali-amount-sub {
  margin-left: 4px;
  color: #999;
  font-size: 12px;
  font-weight: normal;
}
.as-ali-ww-icon {
  margin-left: 6px;
  cursor: pointer;
  color: #1966ff;
  font-size: 16px;
  vertical-align: middle;
}
.as-ali-ops {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #eee;
}
.as-ali-ops-hd {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.as-ali-ops-empty-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  margin: 0;
}
.as-pro-img {
  width: 72px;
  height: 72px;
  border-radius: 6px;
  overflow: hidden;
  background: #eee;
  flex-shrink: 0;
}
.as-pro-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.as-ph-img {
  background: linear-gradient(135deg, #f0f0f0, #e0e0e0);
}
.as-pro-title {
  font-size: 14px;
  color: #333;
  margin: 0 0 8px;
  line-height: 1.4;
}
.as-pro-meta,
.as-pro-spec {
  font-size: 12px;
  color: #999;
  margin: 4px 0;
}
.as-pro-tags .el-tag {
  margin-right: 6px;
}
.as-trade-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  font-size: 12px;
  color: #666;
  padding-top: 14px;
}
.as-tip-icon {
  color: #ccc;
  margin-left: 4px;
}
.as-tl-action {
  font-weight: 600;
  margin: 0 0 4px;
  color: #333;
}
.as-tl-text {
  margin: 0 0 8px;
  color: #666;
  font-size: 13px;
  line-height: 1.5;
}
.as-tl-kvs {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
.as-tl-kvs em {
  font-style: normal;
  color: #999;
}
.as-tl-evidence {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #eee;
  font-size: 12px;
}
.as-tl-evidence-hd {
  margin: 0 0 6px;
  color: #999;
  font-weight: 600;
}
.as-tl-evidence-block + .as-tl-evidence-block {
  margin-top: 8px;
}
.as-tl-evidence-desc {
  margin: 0 0 6px;
  color: #666;
  line-height: 1.5;
}
.as-tl-evidence-imgs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.as-tl-evidence-thumb {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #eee;
  cursor: pointer;
}
.as-timeline-placeholder {
  font-size: 12px;
  color: #999;
  line-height: 1.8;
}
.as-negotiation-toggle {
  text-align: center;
  margin-top: 8px;
  padding-top: 4px;
  border-top: 1px dashed #eee;
}
.as-negotiation-toggle-btn {
  color: #1966ff !important;
  font-size: 13px;
}
.as-negotiation-toggle-btn:hover {
  color: #409eff !important;
}
.as-log-block {
  font-size: 13px;
  color: #333;
  line-height: 2;
}
.as-log-block .label {
  display: inline-block;
  min-width: 88px;
  color: #999;
}
.as-addr {
  margin-top: 8px;
  line-height: 1.6;
}
.as-upload >>> .el-upload {
  border: 1px dashed #ddd;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}
.as-upload-thumb img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
.as-upload-plus {
  font-size: 24px;
  color: #ccc;
}
@media (max-width: 1100px) {
  .as-detail-layout {
    flex-direction: column;
  }
  .as-detail-main {
    position: static;
    max-height: none;
    overflow-y: visible;
  }
  .as-detail-side {
    width: 100%;
  }
  .as-info-row {
    grid-template-columns: 88px 1fr;
  }
}
</style>

<style>
.page_links .el-breadcrumb__inner {
  font-weight: bold !important;
  color: #333 !important;
}
.as-detail-side .el-tabs__item.is-active {
  color: #1966ff;
}
.as-detail-side .el-tabs__active-bar {
  background-color: #1966ff;
}
</style>
<style scoped>
:deep(.has-time .el-button) {
  padding: 7px 15px;
}

:deep(.select_wrap .el-button) {
  margin-top: 14px;
}

:deep(.select_wrap .el-range-editor .el-range-input) {
  font-size: 1em;
}

:deep(.select_wrap .el-input--prefix .el-input__inner){
  padding-left: 96px !important;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 12px !important;
}

:deep(.el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus) {
  border-color: var(--red);
}

:deep(.el-select-dropdown__item.selected) {
  color: var(--red);
}

:deep(.select_wrap .el-input--prefix .el-input__inner:focus ){
  border-color: var(--red);
}

:deep(.el-button) {
  color: #333;
  border-color: #ddd;
}

:deep(.el-button--small) {
  padding: 7px 15px;
}

/*red border color*/
:deep(.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus) {
  border-color: var(--red);
}

/*red color*/
:deep(.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover) {
  color: var(--red);
}

/*red background color*/

:deep(.el-input__icon) {
  line-height: unset;
}

:deep(.el-button--primary, .el-button--primary:hover) {
  background-color: var(--red) !important;
  border-color: var(--red) !important;
  color: #fff !important;
}

:deep(.el-button:hover) {
  border-color: var(--red) !important;
  background-color: rgba(240, 65, 62, 0.1) !important;
  color: var(--red) !important;
}

:deep(.el-date-editor--datetimerange .el-icon-time) {
  line-height: 28px;
}

:deep(.el-date-editor .el-range-separator) {
  width: 20px;
}
.red{
  color: var(--red) !important;
}
</style>
